import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { selectInputHandler } from './input.helpers';

const propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
};

const TextFieldWidget = props => {
	const { onChange, value, ...otherProps } = props;
	const handleChange = selectInputHandler(onChange);

	return (
		<TextField
			value={value}
			onChange={handleChange}
			variant="filled"
			{...otherProps}
		/>
	);
};

TextFieldWidget.propTypes = propTypes;

export default TextFieldWidget;
